import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  "class": "dashboard fs_box_wrapper"
};
var _hoisted_2 = {
  "class": "fs_box fs_dashboard_box fs_box_narrow"
};
var _hoisted_3 = {
  "class": "fs_box_header",
  style: {
    "padding": "10px 15px",
    "font-size": "16px"
  }
};
var _hoisted_4 = {
  "class": "fs_box_head"
};
var _hoisted_5 = {
  key: 0,
  "class": "fs_box_actions"
};
var _hoisted_6 = {
  style: {
    "margin-right": "10px"
  },
  "class": "fcon_status"
};
var _hoisted_7 = {
  key: 0,
  "class": "fs_box_body fs_padded_20"
};
var _hoisted_8 = {
  key: 1
};
var _hoisted_9 = {
  style: {
    "padding": "20px 0px"
  }
};
var _hoisted_10 = {
  "class": "fs_box fs_dashboard_box"
};
var _hoisted_11 = {
  "class": "fs_box_body fs_padded_20"
};
var _hoisted_12 = {
  style: {
    "margin-top": "30px"
  },
  "class": "fs_box fs_dashboard_box"
};
var _hoisted_13 = {
  "class": "fs_box_body fs_padded_20"
};
var _hoisted_14 = {
  key: 0,
  "class": "text-align-center"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");
  var _component_el_breadcrumb = _resolveComponent("el-breadcrumb");
  var _component_el_switch = _resolveComponent("el-switch");
  var _component_el_button = _resolveComponent("el-button");
  var _component_el_skeleton = _resolveComponent("el-skeleton");
  var _component_el_input = _resolveComponent("el-input");
  var _component_trigger_mappers = _resolveComponent("trigger-mappers");
  var _component_action_mappers = _resolveComponent("action-mappers");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_breadcrumb, {
    separator: "/"
  }, {
    "default": _withCtx(function () {
      return [_createVNode(_component_el_breadcrumb_item, {
        to: {
          name: 'connectors'
        }
      }, {
        "default": _withCtx(function () {
          return _cache[7] || (_cache[7] = [_createTextVNode("Data Connectors")]);
        }),
        _: 1 /* STABLE */
      }), _createVNode(_component_el_breadcrumb_item, null, {
        "default": _withCtx(function () {
          return _cache[8] || (_cache[8] = [_createTextVNode("Edit")]);
        }),
        _: 1 /* STABLE */
      }), $data.feed ? (_openBlock(), _createBlock(_component_el_breadcrumb_item, {
        key: 0
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(_toDisplayString($data.feed.title) + " (" + _toDisplayString($data.feed.status) + ")", 1 /* TEXT */)];
        }),
        _: 1 /* STABLE */
      })) : _createCommentVNode("v-if", true)];
    }),
    _: 1 /* STABLE */
  })]), $data.feed ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("span", _hoisted_6, [_createTextVNode("Status: " + _toDisplayString($data.feed.status) + " ", 1 /* TEXT */), _createVNode(_component_el_switch, {
    onChange: _cache[0] || (_cache[0] = function ($event) {
      return $options.updateFeed();
    }),
    "active-value": "published",
    "inactive-value": "draft",
    modelValue: $data.feed.status,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return $data.feed.status = $event;
    })
  }, null, 8 /* PROPS */, ["modelValue"])]), _createVNode(_component_el_button, {
    size: "small",
    type: "primary",
    onClick: _cache[2] || (_cache[2] = function ($event) {
      return $options.updateFeed();
    })
  }, {
    "default": _withCtx(function () {
      return _cache[9] || (_cache[9] = [_createTextVNode("Update Feed")]);
    }),
    _: 1 /* STABLE */
  })])) : _createCommentVNode("v-if", true)]), $data.loading ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", null, [_createVNode(_component_el_skeleton, {
    rows: 3,
    animated: ""
  })])])) : $data.feed ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createVNode(_component_el_input, {
    type: "text",
    placeholder: "Connector Title",
    modelValue: $data.feed.title,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
      return $data.feed.title = $event;
    })
  }, null, 8 /* PROPS */, ["modelValue"])]), _createElementVNode("div", _hoisted_10, [_cache[10] || (_cache[10] = _createElementVNode("div", {
    "class": "fs_box_header",
    style: {
      "padding": "10px 15px",
      "font-size": "16px"
    }
  }, [_createElementVNode("div", {
    "class": "fs_box_head"
  }, [_createElementVNode("h3", null, "Set Your Trigger")])], -1 /* HOISTED */)), _createElementVNode("div", _hoisted_11, [_createVNode(_component_trigger_mappers, {
    onUpdate: _cache[4] || (_cache[4] = function ($event) {
      return $options.updateFeed();
    }),
    onAddTrigger: _cache[5] || (_cache[5] = function (trigger) {
      $data.feed.trigger = trigger;
    }),
    integrations: $data.integrations,
    feed_id: $data.feed.id,
    all_triggers: $data.all_triggers,
    trigger: $data.feed.trigger
  }, null, 8 /* PROPS */, ["integrations", "feed_id", "all_triggers", "trigger"])])]), _createElementVNode("div", _hoisted_12, [_cache[12] || (_cache[12] = _createElementVNode("div", {
    "class": "fs_box_header",
    style: {
      "padding": "10px 15px",
      "font-size": "16px"
    }
  }, [_createElementVNode("div", {
    "class": "fs_box_head"
  }, [_createElementVNode("h3", null, "Then do these tasks")])], -1 /* HOISTED */)), _createElementVNode("div", _hoisted_13, [!$data.feed.trigger ? (_openBlock(), _createElementBlock("div", _hoisted_14, _cache[11] || (_cache[11] = [_createElementVNode("h3", null, "Please setup a trigger first", -1 /* HOISTED */)]))) : (_openBlock(), _createBlock(_component_action_mappers, {
    key: 1,
    mock_data: $data.feed.mock_data,
    onUpdate: _cache[6] || (_cache[6] = function ($event) {
      return $options.updateFeed();
    }),
    actions: $data.feed.actions,
    all_actions: $data.all_actions,
    feed_id: $data.feed.id
  }, null, 8 /* PROPS */, ["mock_data", "actions", "all_actions", "feed_id"]))])])])) : _createCommentVNode("v-if", true)])]);
}